module.exports = __webpack_public_path__ + "assets/img/b-c-4.379520dc.png";